const dateFmt = new Intl.DateTimeFormat('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' });
const timeFmt = new Intl.DateTimeFormat('ru-RU', { hour: '2-digit', minute: '2-digit' });
const shortFmt = new Intl.DateTimeFormat('ru-RU', { day: 'numeric', month: 'short' });

export function formatDate(iso: string | null | undefined) {
  if (!iso) return '—';
  return dateFmt.format(new Date(iso));
}

/** «сегодня, 14:05», «вчера, 09:12», «3 нояб., 11:40» */
export function formatMoment(iso: string) {
  const d = new Date(iso);
  const now = new Date();
  const days = Math.floor(
    (new Date(now.toDateString()).getTime() - new Date(d.toDateString()).getTime()) / 86_400_000,
  );
  const time = timeFmt.format(d);
  if (days === 0) return `сегодня, ${time}`;
  if (days === 1) return `вчера, ${time}`;
  return `${shortFmt.format(d)}, ${time}`;
}

export function initials(fullName: string) {
  const [last, first] = fullName.split(' ');
  return `${first?.[0] ?? ''}${last?.[0] ?? ''}`.toUpperCase();
}

/** Склонение: plural(5, ['сотрудник', 'сотрудника', 'сотрудников']) → «сотрудников» */
export function plural(n: number, forms: [string, string, string]) {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return forms[0];
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return forms[1];
  return forms[2];
}

export function formatSize(bytes: number) {
  if (bytes < 1024) return `${bytes} Б`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} КБ`;
  return `${(bytes / 1024 / 1024).toFixed(1)} МБ`;
}

const dayFmt = new Intl.DateTimeFormat('ru-RU', {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
  timeZone: 'UTC',
});
const dayShortFmt = new Intl.DateTimeFormat('ru-RU', { day: 'numeric', month: 'short', timeZone: 'UTC' });

/** Дата без времени (`2026-11-20`) → «20 ноября 2026». Часовой пояс не сдвигает день. */
export function formatDay(isoDate: string | null | undefined) {
  if (!isoDate) return '—';
  return dayFmt.format(new Date(`${isoDate}T00:00:00Z`));
}

/** «20 нояб. — 3 дек.» */
export function formatRange(start: string, end: string) {
  const s = dayShortFmt.format(new Date(`${start}T00:00:00Z`));
  if (start === end) return s;
  return `${s} — ${dayShortFmt.format(new Date(`${end}T00:00:00Z`))}`;
}

const SIGNS: Record<string, string> = { RUB: '₽', USD: '$', EUR: '€', CNY: '¥' };

export function formatMoney(amount: number | null | undefined, currency: string | null | undefined) {
  if (amount === null || amount === undefined) return '—';
  const n = new Intl.NumberFormat('ru-RU', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(
    amount,
  );
  return `${n} ${SIGNS[currency ?? 'RUB'] ?? currency ?? ''}`.trim();
}

/** Сегодня по местному времени браузера: `2026-11-02`. */
export function todayIso() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
